<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :starting-stock-balance="form.balance"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <EntityReferencesModal
        v-if="clientModalWasOpened"
        title="Клиенты"
        link-slug="clients"
        :preparing-data="form.client_id"
        not-only-ids
        allow-only-one-choise
        @choose="(values) => form.client_id = values"
        @close="clientModalWasOpened = false"
      />
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in labels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset class="form-group__fieldset">
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <ForeignKeyInput
                v-if="value === 'Клиент'"
                :value="form[key]"
                :disabled="actionType === 'read'"
                :record-link="goToClientForm(key)"
                @on-trash-click="form[key] = ''"
                @on-plus-click="clientModalWasOpened = true"
              />
              <select
                v-else-if="value === 'Статус'"
                class="form-control"
                v-model="form.status"
                :disabled="actionType === 'read'"
              >
                <option
                  v-for="value in selectValues"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
              <input
                v-else
                class="form-control"
                :name="key"
                placeholder="Отсутствует"
                :type="inputType[key]"
                :maxlength="maxLength[key]"
                :disabled="actionType === 'read'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { purchaseOrderService } from "@/stock/api-services";

import Form from "@/_shared/widgets/Form";
import ForeignKeyInput from "@/_shared/components/ui/ForeignKeyInput";
import EntityReferencesModal from "@/_shared/components/modals/EntityReferencesModal";

import { useForm, useNotification } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
  ],
  components: {
    Form,
    ForeignKeyInput,
    EntityReferencesModal,
  },
  data() {
    return {
      clientModalWasOpened: false,
      fallbackLink: "/purchase_orders",
      entityName: {
        readonly: "Наряд-заказ",
        modify: "наряд-заказа",
      },
      form: createFromKeys(formsFields.purchaseOrder.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const addingFields = createCopy(this.form);
    await this.setFormFields(addingFields, purchaseOrderService.get).then(() => {
      if (!this.form.status) {
        this.form.status = "в работе";
      }
    });
  },
  computed: {
    selectValues() {
      return formsFields.project.statusValues;
    },
    inputType() {
      return formsFields.purchaseOrder.types;
    },
    maxLength() {
      return formsFields.purchaseOrder.maxLength;
    },
    labels() {
      return formsFields.purchaseOrder.labels;
    },
    validationSchema() {
      return schemas.purchaseOrder;
    },
  },
  methods: {
    goToClientForm(fieldKey) {
      if (this.form[fieldKey]) {
        const { id } = this.form[fieldKey];
        const results = `/clients/${id}`;
        return results;
      }
    },
    async submit() {
      const callback = async () => (
        await purchaseOrderService[this.actionType](this.form)
      );
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/PurchaseOrderForm.vue